<template>
  <div>
    <course-summary v-model="maximizeCard" :module_id="3"></course-summary>
        <div class="con-tab-ejemplo">
          <course-listing-component
            courseApplicationType="General"
          ></course-listing-component>
        </div>
    <!-- <vs-tabs class="unique_cstm_tab">
      <vs-tab label="Standard">
       
      </vs-tab>
      <vs-tab label="Custom" v-if="!schoolAdmin">
        <div class="con-tab-ejemplo">
          <course-listing-component
            courseApplicationType="Custom"
          ></course-listing-component>
        </div>
      </vs-tab>

      <vs-tab label="Shared" v-if="!schoolAdmin">
        <div class="con-tab-ejemplo">
          <course-listing-component
            courseApplicationType="Shared"
          ></course-listing-component>
        </div>
      </vs-tab>
    </vs-tabs> -->

    <!-- <div v-if="sharePopUp">
      <vs-popup class="holamundo"  title="Lorem ipsum dolor sit amet" :active.sync="sharePopUp">
      <user-info-modal
      :courseId="shareCourseId"
      Modaltype="Course"
      :sharedUserList="sharedUserList"
      @updateUserId="updateUserId"
      ></user-info-modal>
    </vs-popup>
    </div> -->
    <!-- {{meta}} -->
    <!-- {{get_homework_subject_id}} -->
  </div>
</template>

<script>
import CourseListingComponent from './Course/CourseListingComponent.vue'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import CourseSummary from '../../analytics/summeryLIst'

export default {
  components: {
    CourseListingComponent,
    CourseSummary
  },
  mixins: [PermissionMiddleware],
  created () {
    const role_permission = parseInt(localStorage.getItem('role_permission'))
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Course')
    }
  },
  data () {
    return {
      maximizeCard: true
    }
  }
}
</script>

<style scoped>
.cstm_list_card .scrollable-container {
  max-height: calc(100vh - 110px);
}
</style>